import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Button, Typography } from '@mui/material';

export default function SplitLayout({ item }) {
    return (
        <Box>
            <Grid position={'relative'} container spacing={6} flexDirection={item.direction ?? 'row'}>
                <Grid size={{md: 6, xs: 12}}> 
                    <Grid container height={1} alignContent={item.align ?? 'unset'}>
                        <Grid size={12}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <Grid container spacing={0}>
                                        <Grid size={12}>
                                            <Typography className='dColor' variant="body1" fontSize={'1.125rem'}>{item?.type}</Typography>
                                        </Grid>
                                        <Grid size={12}>
                                            <Typography className='dColor' fontFamily={'DanmarkURW'} fontSize={'2.875rem'} variant="body1">{item?.title}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid size={12}>
                                    <Typography className='dColor' variant="body1" fontSize={'1rem'}>{item?.desc}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={12} marginTop={{md: 'unset', xs: '20px'}}>
                            <Grid container spacing={4}>
                                <Grid size={6}>
                                    <Button fullWidth sx={item?.btn1Style} variant={item?.btn1Variant ?? 'outlined'} className={item?.btn1Classes}>
                                        {item?.btn1}
                                    </Button>
                                </Grid>
                                <Grid size={6}>
                                    <Button fullWidth sx={item?.btn2Style} variant={item?.btn2Variant ?? 'outlined'} className={item?.btn2Classes}>
                                        {item?.btn2}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{md: 6, xs: 12}} height={{md: '440px', xs: '100%'}} bgcolor={'text.secondary'} position={{md: 'relative', xs: 'absolute'}} zIndex={{md: 'unset', xs: '-1'}} top={0} left={0} width={'100%'}>
                    {
                        item.imageUrl ??
                        <Box component={'img'} src={item?.imageUrl} width={1} height={1} className='fitCover' />
                    }
                </Grid>
            </Grid>
        </Box>
    )
}